<template>
<div v-if="summerFestival">
  <template v-if="!loading">
    <h1>{{ $lang("2020障礙競技挑戰賽") }}</h1>
    <div class="dashed">
      <div class="summer-attention">
        <div v-html="summerFestival.content"></div>
      </div>
      <div v-if="isEnroll || isGroup">
        <p>
          <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
        </p>
        <template v-if="isEnroll">
          <p>
            <span>{{ records && records[0].isChallenge? $lang('TEXT_GROUP_CHALLENGE') : $lang('TEXT_GROUP_ALL') }}</span>
          </p>
          <ul>
            <template v-for="item in records">
              <li v-if="item.status != 'draft'" :key="item.id">
                <span></span>
                <router-link class="submitForm" :to="`obstacle-challenge-game/perview/${item.id}`">{{ item.title }}</router-link>
              </li>
              <li v-else :key="item.id">
                <span>{{ item.title }}</span>
                <!-- <router-link class="btn btn-primary" :to="`obstacle-challenge-game/edit/${item.id}`">{{ $lang("修改") }}</router-link> -->
                <router-link class="btn btn-primary" :to="{path: `obstacle-challenge-game/edit/${item.id}`, query: {number: applyNumber}}">{{ $lang("修改") }}</router-link>
                <b-btn variant="info" @click="handlerDelete(item.id)">{{$lang("刪除")}}</b-btn>
                <router-link variant="info" class="btn btn-danger" :to="`obstacle-challenge-game/edit/${item.id}`">{{ $lang("提交") }}</router-link>
              </li>
            </template>
          </ul>
        </template>
        <template v-if="isGroup">
          <p>
            <span>{{ $lang('TEXT_GROUP_CHALLENGE') }}</span>
          </p>
          <ul>
            <template v-for="item in groups">
              <li v-if="item.status != 'draft'" :key="item.id">
                <span></span>
                <router-link class="submitForm" :to="`obstacle-challenge-game/perview/${item.id}`">{{ item.title }}</router-link>
              </li>
              <li v-else :key="item.id">
                <span>{{ item.title }}</span>
                <router-link class="btn btn-primary" :to="`obstacle-challenge-game/edit/${item.id}`">{{ $lang("修改") }}</router-link>
                <b-btn variant="info" @click="handlerDelete(item.id)">{{$lang("刪除")}}</b-btn>
                <router-link variant="info" class="btn btn-danger" :to="`obstacle-challenge-game/edit/${item.id}`">{{ $lang("提交") }}</router-link>
              </li>
            </template>
          </ul>
        </template>
      </div>
      <template v-if="!isFull">
        <div v-if="!isEnroll || !isGroup">
          <p v-if="!isEnroll && !isGroup">
            {{$lang("TEXT_CHOOSE_OBSTACLE")}}：
          </p>
          <p v-if="!isGroup && !isEnroll">
            <span @click="openModel(2,1)" class="listen-tnc btn">{{$lang("TEXT_CHOOSE_OBSTACLE_CHALLENGE_1")}}</span>
          </p>
             <p v-if="!isGroup && !isEnroll">
            <span @click="openModel(2,2)" class="listen-tnc btn">{{$lang("TEXT_CHOOSE_OBSTACLE_CHALLENGE_2")}}</span>
          </p>
          <p v-if="!isEnroll && !isGroup">
            <span @click="openModel(1)" class="listen-tnc btn">{{$lang("TEXT_CHOOSE_OBSTACLE_ENTERTAINMENT")}}</span>
          </p>
        </div>
      </template>
      <template v-else>
        <p>
          <span>
            <h4>{{ $lang("TITLE_IS_FULL_OBSTACLE")}}</h4>
          </span>
        </p>
      </template>
    </div>
  </template>
  <template v-else>
    <div class="spinner">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </template>
</div>
</template>

<script>
import {
  $apis
} from "@/helper";
import game from "@/components/game";
import List from "@/components/List";
export default {
  components: {
    game,
    List
  },
  data() {
    return {
      loading: true,
      isReadOnly: true,
      isAgree: false,
      records: [],
      groups: [],
      buttonStatus: false,
      applyNumber: ''
    }
  },
  created() {
    this.isLoading();
    this.$store.dispatch("base/getPage");
  },
  methods: {
    isLoading() {
      this.loading = true;
      Promise.all([this.getRecordList(), this.getGroupList()])
        .then(resp => {})
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取报名表记录
    getRecordList() {
      const params = {
        gameType: 'individual'
      }
      return $apis.obstacle.recordList(params)
        .then(resp => {
          if (resp.data.isFull === true) {
            this.notification.error(this.$lang(resp.data.fullMessage));
            this.buttonStatus = true;
          }
          this.records = resp.data.records;
          this.applyNumber= resp.data.applyNumber
        }).catch(err => {
          console.log(err)
        })
    },
    getGroupList() {
      const params = {
        gameType: 'team'
      }
      return $apis.obstacle.recordList(params)
        .then(resp => {
          this.groups = resp.data.records;
          this.applyNumber= resp.data.applyNumber
        }).catch(err => {
          console.log(err)
        })
    },
    // 删除报名表记录
    deleteRecordDetail(id) {
      $apis.obstacle
        .deleteRecordDetail({
          id
        })
        .then(resp => {
          this.notification.success(this.$lang("删除成功"));
          this.getRecordList();
          this.getGroupList();
        })
        .catch(err => {
          this.notification.error(this.$lang("删除失败"));
          console.log(err);
        });
    },
    handlerDelete(id) {
      let r = confirm(this.$lang("是否刪除報名表!"));
      if (r == true) {
        this.deleteRecordDetail(id);
      }
    },
    openModel(val,val2) {
      if (val === 2) {
         if(val2 === 1){
             this.$router.push({
          path: "obstacle-challenge-game",
          query: {
            type: 'individual',
            number: this.applyNumber
          },
        })
         }else{
              this.$router.push({
          path: "obstacle-challenge-game",
          query: {
            type: 'team',
            number: this.applyNumber
          },
        })
         }
      } else {
        this.$router.push({
          path: "obstacle-challenge-game",
          query: {
            type: 'entertainment',
            number: this.applyNumber
          }
        })
      }
    }
  },
  computed: {
    summerFestival() {
      return this.$store.state.base.summerFestival;
    },
    isEnroll() {
      return this.records.length || 0;
    },
    isGroup() {
      return this.groups.length || 0
    },
    isFull() {
      return this.applyNumber <= 0
    }
  }
};
</script>
